import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { RecommendationCardProps } from './types'
import './RecommendationCard.css'

/** Recomendación contextual (DESIGN.md §4): una por pantalla, fondo primary-soft, explica por qué ahora, descartable. */
export function RecommendationCard({ reason, title, price, children, actionLabel, onAction, onDismiss, className }: RecommendationCardProps) {
  const { t } = useTranslation()
  const [gone, setGone] = useState(false)
  if (gone) return null
  return (
    <div className={cx('hp-reco', className)}>
      <div className="hp-reco__top">
        <span className="hp-reco__reason">{reason}</span>
        {onDismiss && (
          <button
            type="button"
            aria-label={t('v2.ds.recommendation.descartar')}
            onClick={() => {
              setGone(true)
              onDismiss()
            }}
            className="hp-reco__dismiss"
          >
            <Icon name="x" size={20} />
          </button>
        )}
      </div>
      <div className="hp-reco__head">
        <span className="hp-reco__title">{title}</span>
        {price && <span className="hp-reco__price tnum">{price}</span>}
      </div>
      {children && <p className="hp-reco__text">{children}</p>}
      {onAction && (
        <button type="button" onClick={onAction} className="hp-reco__action">
          {actionLabel ?? t('v2.ds.recommendation.ver')}
          <Icon name="chevron-right" size={20} />
        </button>
      )}
    </div>
  )
}
